export const GET_ADL_ACTIVITIES_REQUEST = "GET_ADL_ACTIVITIES_REQUEST";
export const GET_ADL_ACTIVITIES_SUCCESS = "GET_ADL_ACTIVITIES_SUCCESS";
export const GET_ADL_ACTIVITIES_FAIL = "GET_ADL_ACTIVITIES_FAIL";

export const GET_APPOINTMENTS_REQUEST = "GET_APPOINTMENTS_REQUEST";
export const GET_APPOINTMENTS_SUCCESS = "GET_APPOINTMENTS_SUCCESS";
export const GET_APPOINTMENTS_FAIL = "GET_APPOINTMENTS_FAIL";

export const GET_TO_APPOINTMENTS_REQUEST = "GET_TO_APPOINTMENTS_REQUEST";
export const GET_TO_APPOINTMENTS_SUCCESS = "GET_TO_APPOINTMENTS_SUCCESS";
export const GET_TO_APPOINTMENTS_FAIL = "GET_TO_APPOINTMENTS_FAIL";

export const GET_UPCOMING_APPOINTMENTS_REQUEST =
  "GET_UPCOMING_APPOINTMENTS_REQUEST";
export const GET_UPCOMING_APPOINTMENTS_SUCCESS =
  "GET_UPCOMING_APPOINTMENTS_SUCCESS";
export const GET_UPCOMING_APPOINTMENTS_FAIL = "GET_UPCOMING_APPOINTMENTS_FAIL";

export const GET_UNREVIEWED_LAB_REPORTS_REQUEST =
  "GET_UNREVIEWED_LAB_REPORTS_REQUEST";
export const GET_UNREVIEWED_LAB_REPORTS_SUCCESS =
  "GET_UNREVIEWED_LAB_REPORTS_SUCCESS";
export const GET_UNREVIEWED_LAB_REPORTS_FAIL =
  "GET_UNREVIEWED_LAB_REPORTS_FAIL";

export const MARKED_LAB_REPORT_REQUEST = "MARKED_LAB_REPORT_REQUEST";
export const MARKED_LAB_REPORT_SUCCESS = "MARKED_LAB_REPORT_SUCCESS";
export const MARKED_LAB_REPORT_FAIL = "MARKED_LAB_REPORT_FAIL";
export const RESET_MARKED_LAB_REPORT = "RESET_MARKED_LAB_REPORT";

export const MARKED_ALL_LAB_REPORTS_REQUEST = "MARKED_ALL_LAB_REPORTS_REQUEST";
export const MARKED_ALL_LAB_REPORTS_SUCCESS = "MARKED_ALL_LAB_REPORTS_SUCCESS";
export const MARKED_ALL_LAB_REPORTS_FAIL = "MARKED_ALL_LAB_REPORTS_FAIL";
